export default __webpack_public_path__ + "static/media/BG-Yellow-0004.3bf56264.png";